import { useQuery } from "@tanstack/react-query";
import { auditLogsApi } from "@/lib/api";

export function useAuditLogs(params?: { skip?: number; limit?: number; table_name?: string; operation?: string }) {
  return useQuery({
    queryKey: ["audit-logs", params],
    queryFn: () => auditLogsApi.list(params),
  });
}

export function useAuditLogsCount(params?: { table_name?: string; operation?: string }) {
  return useQuery({
    queryKey: ["audit-logs", "count", params],
    queryFn: () => auditLogsApi.count(params),
  });
}

export function useAuditLogTables() {
  return useQuery({
    queryKey: ["audit-logs", "tables"],
    queryFn: auditLogsApi.tables,
  });
}